import React from 'react';
import { Layout, Space, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import ProfileMenu from '../menu/ProfileMenu';
import { getDisplayName } from '../../utils/tokenUtil';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store/store';

const { Text } = Typography;

const AppHeader: React.FC = () => {
  const rememberMe = useSelector((state: RootState) => state.auth.rememberMe)
  
  return (
    <>
      <Layout.Header
        style={{
          borderBottom: '1px solid #e1e1e1',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Space>
          <Link to='/'>
            <Text style={{ fontWeight: 600, fontSize: 24 }}>AUTO STREAM</Text>
          </Link>
          <Tag color='#108ee9'>Seller Portal</Tag>
        </Space>
        <Space size={24} style={{ marginLeft: 'auto' }}>
          <Space size={'small'}>
            <ProfileMenu displayName={getDisplayName(rememberMe)} />
          </Space>
        </Space>
      </Layout.Header>
    </>
  );
};

export default AppHeader;
